import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ContactTableHeader from "./ContactTableHeader";
import LoadingCircle from "../LoadingCircle";
import ContactRow from "./Rows/ContactRow";

const GenericContactTable = ({
  isEditMode,
  onAddNew,
  onRowClick,
  onSelectContact, // new prop
  rolesConfig,
  useContactsHook,
  entityId,
  selectedContact, // passed in selected contact for styling
}) => {
  const {
    assignedContacts,
    contactOptions,
    loading,
    handleRowFieldChange,
    handleRowAutoSave,
    addContactForRole,
    removeContactForRole,
  } = useContactsHook(entityId);

  // Build rows based on roles configuration.
  const rows = useMemo(() => {
    return rolesConfig.map((role) => {
      const contact = assignedContacts.find((c) => c[role.roleKey]);
      return {
        roleKey: role.roleKey,
        roleLabel: role.roleLabel,
        contact: contact || null,
        isNew: !contact,
      };
    });
  }, [assignedContacts, rolesConfig]);

  const rowHandlers = {
    contactOptions,
    handleRowFieldChange,
    handleRowAutoSave,
    addContactForRole,
    removeContactForRole,
  };

  if (loading) {
    return (
      <div style={{ zIndex: 1600 }}>
        <LoadingCircle />
      </div>
    );
  }

  return (
    <div className="mb-4 w-full">
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse">
          <thead>
            <ContactTableHeader isEditMode={isEditMode} onAddNew={onAddNew} />
          </thead>
          <tbody>
            {rows.map((row) => (
              <ContactRow
                key={`${row.roleKey}-${row.contact?.contactID || "none"}`}
                row={row}
                mode={isEditMode ? (row.isNew ? "add" : "edit") : "view"}
                handlers={rowHandlers}
                onRowClick={onRowClick}
                onSelectContact={onSelectContact} // pass down the setter function
                selectedContact={selectedContact}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

GenericContactTable.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onAddNew: PropTypes.func,
  onRowClick: PropTypes.func,
  onSelectContact: PropTypes.func, // new prop type
  rolesConfig: PropTypes.array.isRequired,
  useContactsHook: PropTypes.func.isRequired,
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedContact: PropTypes.object,
};

export default GenericContactTable;
